<ng-template [sbmodal]="'ApiKeyModal'">
  <sb-custom-modal [templateId]="'ApiKeyModal'">
    <div slot="body">
      {{ apiKeyString }}
    </div>
  </sb-custom-modal>
</ng-template>

<div class="mr-3">
  <form [formGroup]="form">
    <div class="form-group validateMe">
      <label class="form-label" for="Title">{{ 'lang.globals.name' | translate }}</label>
      <input type="text" id="Title" class="form-control" formControlName="Name">
      <span class="form-text text-muted">{{ 'lang.mediumGroupSettingsEdit.nameDescription' | translate }}</span>
      <div *ngIf="Name.dirty && Name.errors?.required"
           class="alert alert-danger">{{ 'lang.mediumGroupSettingsEdit.nameWarning' | translate }}
      </div>
    </div>
    <div class="form-group validateMe">
      <label class="form-label" for="Expires">{{ 'lang.globals.expiredDate' | translate }}</label>
      <sb-local-date-time-input (modelChange)="expires = $event" [disablePicker]="!!apiKey.identifier"
                                [seconds]="false"
                                id="Expires" class="tw-w-full">
      </sb-local-date-time-input>
    </div>
    <div class="d-flex justify-content-between">
      <button type="button" (click)="apiKeyChanged.emit(null)"
              class="btn btn-default">{{ 'lang.globals.cancel' | translate }}
      </button>
      <button type="submit" (click)="createOrEditApiKey()" [disabled]="!form.valid"
              class="btn btn-success">{{ 'lang.globals.submit' | translate }}
      </button>
    </div>
  </form>
</div>
